import SEO from '../Components/common/SEO';
import React from "react";
import Contact from "../Components/contact/Contact";
import Slider2 from "../Components/common/Slider2";
import Product from "../Components/product/Product";
import Question from "../Components/question/Question";
import About from "../Components/about/About";
import TopBar from "../Components/common/TopBar";
import Counter from "../Components/counter/Counter";
import Spacer2 from "../Components/common/Spacer2";
import Contactus from "../Components/contact/Contactus";

function HomePage() {
  const siteUrl = 'https://seymenkimya.com';
  
  const orgStructuredData = {
    '@context': 'https://schema.org',
    '@type': 'Organization',
    'name': 'Seymen Kimya',
    'url': siteUrl,
    'logo': `${siteUrl}/assets/images/favicons/favicon-32x32.webp`,
    'description': 'Endüstriyel ve ev tipi temizlik ürünlerinde güvenilir çözümler sunan kimya şirketi',
    'address': {
      '@type': 'PostalAddress',
      'addressCountry': 'TR',
      'addressLocality': 'Bursa'
    },
    'contactPoint': {
      '@type': 'ContactPoint',
      'telephone': '+90-224-360-1166',
      'contactType': 'customer service'
    }
  };

  const websiteStructuredData = {
    '@context': 'https://schema.org',
    '@type': 'WebSite',
    'url': siteUrl,
    'name': 'Seymen Kimya Temizlik Ürünleri',
    'description': 'Profesyonel temizlik ürünleri ve kimyasal çözümler',
    'potentialAction': {
      '@type': 'SearchAction',
      'target': `${siteUrl}/urunlerimiz?q={search_term_string}`,
      'query-input': 'required name=search_term_string'
    }
  };

  return (
    <>
      <SEO
        title="Seymen Kimya | Profesyonel Temizlik ve Kimyasal Ürünler"
        description="Endüstriyel ve ev tipi temizlik ürünlerinde güvenilir çözümler. Bulaşık deterjanı, çamaşır suyu, kireç çözücü ve daha fazlası. Kaliteli kimyasal ürünler."
        canonical={siteUrl}
        image={`${siteUrl}/assets/images/slider/1.webp`}
        structuredData={[orgStructuredData, websiteStructuredData]}
      />
      <Slider2 />
      <About />
      <Product />
      <Contact />
    </>
  );
}

export default HomePage;
